import { Component, OnInit, Input, Injector, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseService } from '../../shared/services/base.service';
import { AlertsService } from '../../services/alerts.service';
import { ModalSize, SmartModalService } from '../../services/smart-modal.service';
import { ModalService } from '../../services/modal.service';
import { MainComponent } from '../main-component/main.component';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { CommonService } from '../../services/common.service';

@Component({
    selector: 'kx-form-with-grid',
    templateUrl: './form-with-grid.component.html',
    styleUrls: ['./form-with-grid.component.scss'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: FormWithGridComponent,
            multi: true,
        }],
    standalone: false
})
export class FormWithGridComponent extends MainComponent implements ControlValueAccessor, OnInit {
  @Input('value') _value: any;
  @Input() dataResource: any;
  @Input() data: any;
  @Input() pagination: boolean = true;
  public filterFormMapping: any = false;
  public filterFormGroup: any = false;
  propagateChange = (_: any) => { };
  freshMedicineArr: any;
  secondArr: any = [];
  _gridData: any = {};
  page_size: number = 10;
  page_no: number = 0;
  itemsCount1: any = 0;
  itemsCount2: any = 0;
  isSuplier: boolean = false; // This code willl be deleted in refactoring
  search1: any = "";
  search2: any = "";
  showGrid: boolean = true;
  supplierElm: any;
  key1: string = "Seach By:--";
  key2: string = "Seach By:--";
  config: any = {};
  dropdowns: any = [];
  @Input() action: any;
  @Input() controlName: any;

  key_: string;
  fieldGroup: any;
  configList: any;
  limit1: any = 10;
  limit2: any = 10;
  page = 1;
  limit = 10;

  constructor(
    public injector: Injector,
    public route: ActivatedRoute,
    public smartModalService: SmartModalService,
    public modalService: ModalService,
    public baseService: BaseService,
    public alertify: AlertsService,
    private elementRef: ElementRef,
    public commonService?: CommonService
  ) {
    super(injector, route);
  }

  ngOnInit() {
    this.configList = {
      "viewAll": true,
      "hideSearchBox": true,
      "hideResult": true,
      "allowPagination": false,
    }
    this.config.filter_0 = false;
    this.config.filter_1 = false;

    if (this.action == undefined) {
      console.log("data Resource is ", this.dataResource);
      console.log("data is ", this.data);
      // let r = this.dataResource.table.map(x=>x.config.complex_search )
      // this.dataResource = r;
      if (this.data == undefined) {
        var obj = {};
        var formData = this.controlName.controls;
        Object.keys(formData).forEach(function (key) {
          obj[key] = formData[key].value
        });
        this.data = obj;
      }
      this.get1stGridDataItmes(this.page_no);
      if (this.dataResource.table[1].hitDefault != undefined) {
        this.get2ndGridDataItmes(this.page_no);
      }

      if (document.getElementById('supplierId')) {
        this.supplierElm = <Element>document.getElementById('supplierId');
        this.isSuplier = true;
        this.supplierElm.addEventListener("change", (event) =>
          (this.supplierElm.selectedOptions[0].value) ? this.bindDataBasedOnSuplierId() : console.log("blank"))
      }
    }
    if (this.value != undefined && this.action == 'VIEW') {
      this.fieldGroup = [];
      for (let i = 0; i < this.dataResource.table.length; i++) {
        if (this.dataResource.table[i].view != undefined && this.dataResource.table[i].view) {
          let column = this.dataResource.table[i].column.split(',');
          let key = this.dataResource.table[i].key.split(',');
          for (let i = 0; i < column.length; i++) {
            this.fieldGroup.push({
              "heading": column[i],
              "order": i + 1,
              "sortable": true,
              "name": key[i]
            });
          }
          //"column": "Test Name,Department,Sub Department,Result Type,Service Code,Sequence",
          //"key": "testName,department,subDepartment,resultType,serviceCode,sequence",

        }
      }
      console.log("Data is as", this.fieldGroup);
      this.secondArr['resource'] = this.value;
    }
  }
  bindDataBasedOnSuplierId() { // code will remove 

    this.get1stGridDataItmes(this.page_no, "", this.getSuplierId());
    this.get2ndGridDataItmes(this.page_no, "", this.getSuplierId());
  }
  getSuplierId() {      //Code will remove with time
    let filters;
    if (this.supplierElm != undefined) {
      filters = `supplierId:${this.supplierElm.selectedOptions[0].value ? this.supplierElm.selectedOptions[0].value : ''}` // need to remove // need to remove
    }
    return filters;
  }
  ngAfterViewInit() {
  }
  setItem(item: object, selectedObj: object) {  /// Function will called on add and delete icon
    console.log("Items is", item);
    console.log("seleccted obj is", selectedObj);
    if (item['add'] != undefined && item['add']) {
      if (!this.secondArr.find(x => x[item['unique_key']] == selectedObj[item['unique_key']])) {
        this.secondArr.push(selectedObj);
      }
      else {
        this.alertify.error("Already Added");
      }
      this.value = this.secondArr;
    }
    else {
      if (this.supplierElm == undefined) {
        var res = selectedObj;
        let loopData = item['addAPI']['data'][0];
        Object.keys(loopData).forEach(set => {
          res[set] = this.data[loopData[set]];
        });
        this.saveData(res, item['addAPI']);
      }
      // Hardcoded keys should be removed.Instead JSON keys should be used. 
      else {
        if (this.supplierElm.selectedOptions[0].value) {
          var duplicateArr = this.secondArr.filter(x => x['itemCode'] == selectedObj['itemCode']);
          if (duplicateArr.length == 0) {
            var args = {
              "supplierId": this.supplierElm.selectedOptions[0].value,
              "supplierName": this.supplierElm.selectedOptions[0].innerText,
              "itemName": selectedObj['itemName'],
              "itemTypeKey": selectedObj['itemTypeKey'],
              "itemTypeDisplay": selectedObj['itemTypeDisplay'],
              "itemCategoryKey": selectedObj['itemCategoryKey'] ? selectedObj['itemCategoryKey'] : '',
              "itemSubcategoryKey": selectedObj['itemSubcategoryKey'] ? selectedObj['itemSubcategoryKey'] : '',
              "itemCategoryKeyName": selectedObj['itemCategoryKeyName'] ? selectedObj['itemCategoryKeyName'] : '',
              "itemSubCategoryKeyName": selectedObj['itemSubCategoryKeyName'] ? selectedObj['itemSubCategoryKeyName'] : '',
              "itemCode": selectedObj['itemCode'],
              "status": selectedObj['status'],
              "genericNameKey": selectedObj['genericNameKey'],
              "genericNameDisplay": selectedObj['genericNameDisplay'] ? selectedObj['genericNameDisplay'] : '',
              "displayName": selectedObj['displayName'],
              "chargeInFactorOf": selectedObj['chargeInFactorOf']
            }
            this.secondArr.push(selectedObj);
            this.baseService.add(args).subscribe(
              (res => {
                if (res.errCode == 0) {
                  this.get2ndGridDataItmes(this.page_no);
                  this.alertify.success(res.message);
                } else if (res.errCode == -1) {
                  this.secondArr.pop(selectedObj);
                  this.alertify.error(res.message);
                }
              }), (err => {

              })
            );
          }
          else {
            this.alertify.error("Already Added");
          }
        } else {
          this.alertify.error("Please select supplier first.");
        }
      }
    }
  }
  saveData(res, action) { // save data for particular action
    this.baseService.action(res, action.action, action.application, action.resource).subscribe(
      (data: any) => {
        this.communicationService.emitChange({ completed: true });
        if (data.errCode == -1) {
          this.alerts.error(data.message);
        } else {
          if (action == 'ADD') {
            this.alerts.success("Added Successfully");
          } else {
            this.alerts.success("Updated Successfully");
          }
          this.get1stGridDataItmes(this.page_no);
          this.get2ndGridDataItmes(this.page_no);
        }
        this.loader.hideSpinner();
      }, error => {
        console.log(error);
        this.alerts.error('API error');
        this.loader.hideSpinner();
      }
    )
  }
  deleteResource(item: string) { // Delete item from selected data
    this.baseService.action({ id: item }, 'DELETE').subscribe(
      (data: any) => {
        if (data.errCode == -1) {
          this.alertify.error(data.message);
        } else {
          this.alertify.success("Deleted Successfully");
          this.get2ndGridDataItmes(this.page_no, "", "");
        }
      }, error => {
        this.alertify.error('API error');
      }
    )
  }
  deleteItem(data, key, item?) { // confirm delete box
    console.log("Data ", data, " Key is ", key, " Item is ", item);
    if (item['addAPI']) {
      var res = data;
      let loopData = item['addAPI']['data'][0];
      Object.keys(loopData).forEach(set => {
        res[set] = this.data[loopData[set]];
      });

      this.saveData(res, item['addAPI']);
    } else {
      let name: string = "";
      if (data.name != undefined) {
        name = data.name;
      } else {
        name = "";
      }
      const dialogRef = this.modalService.confirm('DELETE', 'Are you sure you want to delete ' + name + '?', ModalSize.Sm);
      dialogRef.subscribe(result => {
        if (item.add) {
          const index = this.secondArr.indexOf(data);
          if (index > -1) {
            this.secondArr.splice(index, 1);
          }
          this.value = this.secondArr;
        }
        else {
          if (result) {
            this.deleteResource(key);
          }
        }

      },
        () => { });
    }
  }
  get1stGridDataItmes(page_no: number, search?: any, filter?, page_size?) { // get first grid data
    // debugger;
    this.limit1 = page_size ? page_size : 10,
      this.loader.showSpinner();
    var gridData = {
      page_size: page_size ? page_size : 10,
      page_no: page_no,
      search: search == undefined ? '' : (typeof search == 'object' ? search.value : search),
      filter: filter == undefined ? '' : filter,
    };

    if (typeof search === 'object') {
      gridData['search_columns'] = search.key
      gridData['searchColumns'] = search.key
      gridData['searchLabel'] = search.label
    }
    if (this.isSuplier) {
      if (gridData['filter'] != '' && gridData['filter'] != undefined) {
        gridData['filter'] += `,${this.getSuplierId()}`;
      } else {
        gridData['filter'] += `${this.getSuplierId()}`;
      }
    }
    if (this.dataResource.args != undefined && this.dataResource.args) {
      gridData['args'] = this.dataResource.args;
    }
    if (this.dataResource['table'][0]['args']) {
      gridData['args'] = this.makeArgs(this.dataResource['table'][0]['args'][0], this.data);
    }
    this.baseService.getData(gridData, "", this.dataResource['table'][0]['resource'], "", this.dataResource['table'][0]['query_id']).subscribe(
      (res => {
        if (res.errCode == -1) {
          this.alertify.error(res.message);
          this.itemsCount1 = res.count;
          this.loader.hideSpinner();
        } else if (res.errCode == 0) {
          this.itemsCount1 = res.count;
          this.freshMedicineArr = res['resource'];
          this.loader.hideSpinner();
        } else {
          this.freshMedicineArr = [];
        }
      }), (err => {
        this.alertify.error(err.message);
        this.loader.hideSpinner();
        this.freshMedicineArr = [];
      })
    )
  }
  get2ndGridDataItmes(page_no: number, search?: any, filter?: any, pageLimit?) { // get second grid data
    this.loader.showSpinner();
    this.limit2 = pageLimit ? pageLimit : 10;
    var gridData = { //
      page_size: pageLimit ? pageLimit : 10,
      page_no: page_no,
      search: search == undefined ? '' : search,
      filter: filter ? filter : "",
    };
    if (this.isSuplier) {
      if (gridData['filter'] != '' && gridData['filter'] != undefined) {
        gridData['filter'] += `,${this.getSuplierId()}`;
      } else {
        gridData['filter'] += `${this.getSuplierId()}`;
      }
    }
    if (this.dataResource['table'][1]['args']) {
      gridData['args'] = this.makeArgs(this.dataResource['table'][1]['args'][0], this.data);
    }
    this.baseService.getData(gridData, "", this.dataResource['table'][1]['resource'], "", this.dataResource['table'][1]['query_id']).subscribe(
      (res => {
        if (res.errCode == -1) {
          this.loader.hideSpinner();
          this.alertify.error(res.message);
          this.itemsCount2 = res.count;
        } else if (res.errCode == 0 && res['resource'].length > 0) {
          this.loader.hideSpinner();
          this.itemsCount2 = res.count;
          this.secondArr = res['resource'];
        } else {
          this.secondArr = [];
          this.loader.hideSpinner();
        }
      }), (err => {
        this.secondArr = [];
        this.loader.hideSpinner();
      })
    )
    return this.secondArr;
  }
  makeArgs(resp, data) {
    ///let resp = resouceDef.args[0];
    var obj = [];
    for(let i = 0; i < Object.keys(resp).length; i++) {
      if (resp[Object.keys(resp)[i]] == '' || resp[Object.keys(resp)[i]] == undefined) {
        obj.push(Object.keys(resp)[i] + ":" + data[Object.keys(resp)[i]])
      } else {
        obj.push(Object.keys(resp)[i] + ":" + resp[Object.keys(resp)[i]]);
      }
    }
    obj.toString();
    console.log("obj is as follows::", obj);
    return obj;
  }
  onPageChanged1(event: any, filter, index) {

    //this.page = event.page;
    this.applyFilter(event.page - 1, filter, index, this.limit1);
    // this.get1stGridDataItmes(event.page - 1);
  }
  onPageChanged2(event: any, filter, index) {
    //this.page = event.page;
    this.applyFilter(event.page - 1, filter, index, this.limit2);
    // this.get2ndGridDataItmes(event.page - 1);
  }
  onFilterClick1(event) {
    this.get1stGridDataItmes(this.page_no, event);
  }
  onFilterClick2(event) {
    this.get2ndGridDataItmes(this.page_no, event);
  }
  ngAfterViewChecked() {

  }
  bindDdl(obj) {
    if (obj.type == 'dropdown' && !(obj.dependent)) {
      var args = "";
      if (obj.hasOwnProperty('default_args')) {
        args = obj.default_args;
      }
      this.bindDropDowns(obj, args);
    }
  }
  applyDdlFilter(event, index, obj) {
    if (obj.dependentField != '') {
      var value = document.getElementById(obj.getterKey + obj.type + index)['value']
      var args = (value != "" || value != undefined) ? obj.getterKey + ":" + value : "";
      if (value) {
        this.bindDropDowns(obj, args, obj.dependentField);
      } else {
        this.dropdowns[obj.dependentField] = [];
      }
    } else {
      this.bindDropDowns(obj, args, obj.dependentField);
    }
  }
  bindDropDowns(obj, args?, getterKey?) { // Bind drop Downs
    if (args == undefined) {
      args = "dummy:dummy";
    } else {
      args = args;
    }
    this.baseService.getDataAsPerResource(obj.query_id, args, obj.resource, obj.application).subscribe(
      (res => {
        if (res.errCode == -1) {
          //this.alertify.error(res.message);
        } else if (res.errCode == 0 && res['resource'].length > 0) {
          // this.dropdowns.push(obj.getterKey); 
          console.log("keey genrated", this.dropdowns);
          if (getterKey == undefined) {
            this.dropdowns[obj.getterKey] = res['resource'];
          } else {
            this.dropdowns[getterKey] = res['resource'];
          }
        } else {
          var index = this.dropdowns.indexOf(obj.getterKey);
          if (index > -1) {
            this.dropdowns.splice(index, 1);
          }
        }
      }), (err => {
        // this.secondArr = [];
      }),
    )
    console.log("Dropdowns are as follows::", this.dropdowns);
    return this.dropdowns;
  }

  limitChange1(event) {
    this.applyFilter(0, "", 0, event.target.value);
  }
  limitChange2(event) {
    this.applyFilter(0, "", 1, event.target.value);
  }

  applyFilter(pageno, filter, index, pageLimit?) {
    //debugger; // filter grid 1 data
    // var filters = "";
    // var search = "";
    // for(let id of filter) {
    //   var key = id['getterKey'] + id['type'] + index;
    //   var value = document.getElementById(key)['value'];
    //   if (value != undefined && value != '' && id.type == 'dropdown') {
    //     filters += [id['getterKey']] + ":" + value + ",";
    //   } else {
    //     search = document.getElementById(key)['value'];
    //   }
    // }
    let filters = "";
    if (this.supplierElm != undefined) {
      filters = `supplierId:${this.supplierElm.selectedOptions[0].value ? this.supplierElm.selectedOptions[0].value : ''}` // need to remove // need to remove
    }
    if (index == 0) {
      this.get1stGridDataItmes(pageno, "", filters, pageLimit);
    } else if (index == 1) {
      this.get2ndGridDataItmes(pageno, "", filters, pageLimit);
    }

  }
  get value() {
    return this._value;
  }

  set value(val) {
    this.secondArr = val;
    this.propagateChange(val);
  }

  writeValue(value) {
    if (value || (this.value != undefined && this.value.length > 0)) {
      this.secondArr = value || this.value;
    }
    else {
      this.secondArr = [];
    }
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }
  registerOnTouched(fn: any): void {

  }
  //gettting field type
  getfieldType(field: string) {
    if (field.includes("sequence")) {
      return false;
    }
    else {
      return true;
    }
  }

  isUniqueBarCodeField(field: string) {
    return field.includes("UniqueBarCode");
  }

  checkactionAondition(hasCheck: any) {
    if (hasCheck.hasOwnProperty("action") == false) {
      return true;
    } else if (hasCheck['action'] == true) {
      return true;
    } else if (hasCheck['action'] == false) {
      return false;
    }
  }
  displayFilter(i) {
    this.config.filter_0 = !this.config.filter_0;
  }
  displayFilter_1() {
    this.config.filter_1 = !this.config.filter_1;
  }
  doSearch(filter, index) {
    console.log("data is", filter);
    console.log("index is", index);
    if (index === 0) {
      this.get1stGridDataItmes(this.page_no, "", filter);
      this.displayFilter(index);
    } else if (index === 1) {
      this.get2ndGridDataItmes(this.page_no, "", filter);
      this.displayFilter_1();
    }
  }
  resetFilter(filter, index) {
    let filters = "";
    if (this.supplierElm != undefined) {
      filters = `supplierId:${this.supplierElm.selectedOptions[0].value ? this.supplierElm.selectedOptions[0].value : ''}` // need to remove
    }
    console.log("data is", filter);
    console.log("index is", index);
    if (index === 0) {
      this.get1stGridDataItmes(this.page_no, "", filters);
      this.displayFilter(index);
    } else if (index === 1) {
      this.get2ndGridDataItmes(this.page_no, "", filters);
      this.displayFilter_1();
    }
  }
  filterClick(event, i) {
    this.page = 0;
    if (i == 0)
      this.get1stGridDataItmes(this.page_no, event);
    else
      this.get2ndGridDataItmes(this.page_no, event);
    // this.complexSearchRef.handleKeyEnter()
  }
}


